import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_SubstituteMaintenance } from "../../shared/data.service";

@Component({
	selector: "app-sub-history-details",
	templateUrl: "./sub-history-details.component.html",
	styleUrls: ["./sub-history-details.component.css"],
})
export class SubHistoryDetailsComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private SubstituteHistoryDetailsService: DataService_SubstituteMaintenance
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.SubstitutionID = this.dialogConfig.data.SubstitutionID;

		this.loadClassAttendanceStudent();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	SubstitutionID: any = -1;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedClassAttendanceStudent: any;
	lstClassAttendanceStudent: any = [];

	//Filter lists
	lstCourseCD: any = [];
	lstSectionNo: any = [];
	lstPeriodNo: any = [];
	lstRoomNo: any = [];
	lstClassAttendanceStatusDesc: any = [];
	lstClassAttendanceExcuseDesc: any = [];

	//Cols
	cols1: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "CourseCD", header: "Course" },
		{ field: "SectionNo", header: "Section" },
		{ field: "PeriodNo", header: "Period" },
		{ field: "RoomNo", header: "Room" },
		{ field: "StudentName", header: "Student" },
	];

	cols2: any = [
		{ field: "ClassAttendanceExcuseDesc", header: "Excuse" },
		{ field: "EntryTimeDesc", header: "Entry Time" },
		{ field: "ExitTimeDesc", header: "Exit Time" },
		{ field: "EntryDateDesc", header: "Entry Date" },
		{ field: "SubmittedDTDesc", header: "Last Updated" },
		{ field: "LastEditedBy", header: "Last Updated By" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadClassAttendanceStudent() {
		if (this.SubstitutionID <= 0) {
			return;
		}

		this.loading = true;

		var result = this.SubstituteHistoryDetailsService.SubHistoryDetailsTableInfoSelectList(this.SubstitutionID);
		result.subscribe(
			(response) => {
				this.lstClassAttendanceStudent = response;

				//Load Data Filter Lists
				this.lstCourseCD = Array.from(new Set(this.lstClassAttendanceStudent.map((item: any) => item.CourseCD))).sort();
				this.lstSectionNo = Array.from(new Set(this.lstClassAttendanceStudent.map((item: any) => item.SectionNo))).sort();
				this.lstPeriodNo = Array.from(new Set(this.lstClassAttendanceStudent.map((item: any) => item.PeriodNo))).sort();
				this.lstRoomNo = Array.from(new Set(this.lstClassAttendanceStudent.map((item: any) => item.RoomNo))).sort();
				this.lstClassAttendanceStatusDesc = Array.from(
					new Set(this.lstClassAttendanceStudent.map((item: any) => item.ClassAttendanceStatusDesc))
				).sort();
				this.lstClassAttendanceExcuseDesc = Array.from(
					new Set(this.lstClassAttendanceStudent.map((item: any) => item.ClassAttendanceExcuseDesc))
				).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadClassAttendanceStudent();
	}

	//Custom Button Methods

	onClose() {
		this.ref.close(0);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedClassAttendanceStudent = val.data;
	}
	onRowUnselect(val) {
		this.SelectedClassAttendanceStudent = null;
	}
	onRowDblClick(ClassAttendanceStudent) {
		this.SelectedClassAttendanceStudent = ClassAttendanceStudent;
	}
	////////////////////////////////////////////
}
